module.exports = __webpack_public_path__ + "static/media/survey.d94ce7a9.svg";